export default {
    blackTranslucent: 'blackTranslucent',
    white:            'white',
};